import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { isEmpty, omit } from 'lodash';
import { cloneDeep, isEqual } from 'lodash/lang';

import { AdjustmentList } from 'components/pages/study/ExpenseFixed/ExpenseFixedList/FullExpenseFixedInformation/AdjustmentList/AdjustmentList';

import { FinBudgetExpenseFixedApi } from '../../../../../../api';
import Loader from '../../../../../../common/elements/Loader/Loader';
import { onRequestError } from '../../../../../../services/handlers';
import { CommentSection } from '../../ExpenseFixedList/FullExpenseFixedInformation/CommentSection/CommentSection';
import { ExpenseInfoItem } from '../../ExpenseFixedList/FullExpenseFixedInformation/ExpenseInfoItem/ExpenseInfoItem';
import { getNormalizedDate } from '../../ExpensesServices';
import { ExpenseVariableUploadedFiles } from '../AddExpenseVariable/ExpenceVariableUploadedFiles/ExpenseVariableUploadedFiles';
import { ExpenseVariableAmountSection } from '../AddExpenseVariable/ExpenseVariableAmountSection/ExpenseVariableAmountSection';

export const VariableExpenseDetails = ({
  selectedVariableExpenseId,
  selectedVariableExpenses,
  setUpdatedExpenseVariableData,
  setIsExpenseWasUpdated,
  selectedSSU,
  isUserHaveAccessToManageExpenses
}) => {
  const [expenseVariableData, setExpenseVariableData] = useState(null);
  const [newComment, setNewComment] = useState('');
  const [addCommentMode, setAddCommentMode] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [initialFiles, setInitialFies] = useState([]);

  useEffect(() => {
    if (selectedVariableExpenseId) {
      FinBudgetExpenseFixedApi.getExpenseVariableDetails(selectedVariableExpenseId, selectedSSU.ssuIdentifier).then(
        ({ data }) => {
          const files = data.files.map(file => ({
            contentForPreview: file.content,
            ...file
          }));
          setExpenseVariableData(omit(data, 'files'));
          setUploadedFiles(files);
          setInitialFies(cloneDeep(files));
        },
        onRequestError
      );
    }
  }, [selectedVariableExpenseId, selectedSSU.ssuIdentifier]);

  useEffect(() => {
    const normalizedFiles = uploadedFiles.map(file => {
      return file.fileData ? omit(file, ['id', 'contentForPreview']) : omit(file, ['contentForPreview']);
    });
    setUpdatedExpenseVariableData({ newComment: newComment.trim(), uploadedFiles: normalizedFiles });
    setIsExpenseWasUpdated(!!newComment.trim() || !isEqual(initialFiles, uploadedFiles));
  }, [initialFiles, newComment, setIsExpenseWasUpdated, setUpdatedExpenseVariableData, uploadedFiles]);

  if (isEmpty(expenseVariableData)) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%'
        }}
      >
        <Loader dark={true} />
      </Box>
    );
  }

  return (
    <>
      <CommentSection
        comments={expenseVariableData?.comments}
        setEditedComment={setNewComment}
        editedComment={newComment}
        editCommentMode={addCommentMode}
        setEditCommentMode={setAddCommentMode}
        isUserHaveAccessToManageExpenses={isUserHaveAccessToManageExpenses}
      />
      <ExpenseInfoItem label="Event Date" text={getNormalizedDate(expenseVariableData?.eventDate)} />
      <ExpenseInfoItem label="Revenue Date" text={getNormalizedDate(expenseVariableData?.revenueDate)} />
      <ExpenseInfoItem label="Variable Expense - Event Name" text={expenseVariableData?.eventName || 'N/A'} />
      <AdjustmentList expenses={selectedVariableExpenses} expenseType={'Expense'} />
      {isUserHaveAccessToManageExpenses && (
        <ExpenseVariableAmountSection
          sx={{ marginBottom: '12px' }}
          amount={expenseVariableData?.clientAmount}
          maximumEventAmount={expenseVariableData?.maxAmount}
          totalAmount={expenseVariableData?.totalAmount}
        />
      )}
      <ExpenseInfoItem label="Status" text={expenseVariableData?.eventStatus || 'N/A'} />
      <ExpenseInfoItem label="Added By" text={expenseVariableData?.addedBy || 'N/A'} />
      {isUserHaveAccessToManageExpenses && (
        <ExpenseVariableUploadedFiles
          uploadedFiles={uploadedFiles}
          setUploadedFiles={setUploadedFiles}
          ssuId={selectedSSU.ssuIdentifier}
        />
      )}
    </>
  );
};
